import { observable, computed, makeObservable } from 'mobx';

import { createModelSchema, primitive, object } from 'serializr';

import { Contact } from '@vromo/models';
import { Upload } from '@vromo/models';

import { optional } from '@vromo/models';

class UserPayment {
    paypal: string | null = null;

    constructor() {
        makeObservable(this, {
            paypal: observable
        });
    }
}

createModelSchema(UserPayment, {
    paypal: optional(primitive())
});

export class User {
    id: number | null = null;
    created = null;

    avatar: Upload | null = null;
    contact: Contact | null = null;
    apiHost = 'prod-api.spatula.io';

    payment: UserPayment | null = null;

    get initials() {
        const name =
            (this.contact && this.contact.name) || (this.contact && this.contact.email) || '';
        const initial = name.match(/\b\w/g) || [];

        return ((initial.shift() || '') + (initial.pop() || '')).toUpperCase();
    }

    get displayName() {
        return this.contact?.name || this.contact?.email;
    }

    constructor(init?: Partial<User>) {
        makeObservable(this, {
            id: observable,
            created: observable,
            avatar: observable,
            contact: observable,
            apiHost: observable,
            payment: observable,
            initials: computed,
            displayName: computed
        });

        Object.assign(this, init);
    }
}

createModelSchema(User, {
    id: optional(primitive()),
    created: optional(primitive()),

    avatar: optional(object(Upload)),
    contact: optional(object(Contact)),
    apiHost: primitive(),

    payment: optional(object(UserPayment))
});
